import React from "react";
import Muni1 from "../images/muni1.png";
import Muni2 from "../images/muni2.png";
import Localidadnota from "../images/localidadnota.png";

import Localidad1 from "../images/localidad1.png";
import Localidad2 from "../images/localidad2.png";
import Localidad3 from "../images/localidad3.png";
import FondoMuni from "../images/fondomuni.png";
import { Helmet } from "react-helmet";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoMuni + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 500,
    width: "100%",
    marginTop: 40,
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
    [theme.breakpoints.down("sm")]: {
      minHeight: 800,
      backgroundPosition: "50%",
    },
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 4: Mi localidad"
        meta={[
          {
            property: "og:title",
            content: "Lámina 4: Mi localidad",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Nuestra localidad es el espacio en el que vivimos y que compartimos con nuestros vecinos.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="4" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={7} md={12} xs={12}>
            <Title title="Mi localidad" color="primary" />
            <p>
              Nuestra localidad es el espacio en el que vivimos y que
              compartimos con nuestros vecinos. Debido a su ubicación y a las
              actividades que en ella se realizan, tiene características
              particulares. Observa las siguientes imágenes que corresponden a
              diversas localidades del Perú y presta atención a lo que sus
              habitantes dicen de ella.
            </p>
            <img src={Localidadnota} style={{ maxWidth: 350 }} alt="Escuela" />
          </Grid>
          <Grid item lg={5} md={12} xs={12}>
            <Grid
              container
              className={classes.root}
              spacing={2}
              alignItems="center"
              justify="center"
            >
              <Grid item lg={7} md={7} sm={7} xs={12}>
                <img src={Localidad1} alt="Localidad" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <img src={Localidad2} alt="Localidad" />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <img src={Localidad3} alt="Localidad" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>Responde de manera escrita o verbal:</strong>
        </p>
        <ul>
          <li>¿Cuál es el nombre de la localidad en la que vives?</li>
          <li>¿Qué espacios públicos hay en ella?</li>
          <li>¿Qué te gusta y qué no te gusta de tu localidad? ¿Por qué?</li>
          <li>¿Qué te gustaría que tuviera?</li>
        </ul>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="La municipalidad" color="primary" />
        <p>
          Es la institución encargada del gobierno de los distritos. En el
          recuadro se describen algunos de los servicios que brindan las
          municipalidades en sus localidades.
        </p>
        <Actividad color="primary" />
        <p>
          <strong>
            Escribe en cada imagen la letra que corresponde al servicio que se
            observa.
          </strong>
        </p>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={5} md={5} xs={12}>
            <img src={Muni1} style={{ maxWidth: 300 }} alt="Muni1" />
          </Grid>
          <Grid item lg={7} md={7} xs={12}>
            <img src={Muni2} alt="Muni2" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <div className={classes.actividadFondo}>
          <p style={{ color: "#0072bc" }}>
            <strong>
              En situaciones de emergencia, como la que se vive en el Perú y en
              el mundo en los últimos meses, las municipalidades pueden además
              asumir funciones especiales, como llevar víveres y ayuda directa a
              las familias, realizar campañas de desinfección y reorganizar el
              uso de los espacios públicos para asegurar el bienestar de la
              población.
            </strong>
          </p>
          <p>
            <strong>Conversa con alguien de tu familia y respondan:</strong>
            en el contexto actual, ¿la municipalidad de tu localidad viene
            cumpliendo adecuadamente con su rol de brindar servicios y cuidar a
            los vecinos? ¿Por qué?
          </p>
        </div>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-4.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 4: Mi localidad'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="La importancia de la escuela"
        anteriorEnlace="/lamina-1-3"
        siguiente="Las personas que nos cuidan"
        siguienteEnlace="/lamina-1-5"
      />
    </>
  );
};

export default Lamina2;
